export enum EnvironmentMode {
    DEVELOPMENT = 'development',
    TEST        = 'test',
    PRODUCTION  = 'production',
    LOCAL  = 'local'
}
